import {
    Button,
    Container,
    CssBaseline,
    IconButton,
    Paper,
    TableContainer,
} from "@mui/material";

import CalculateIcon from "@mui/icons-material/Calculate";
import RekendeelTable from "./RekendeelTable";

export default function Rekendeel(props) {

    const fhMinus1 = props.fhMinus1;
    const fhMinus2 = props.fhMinus2;
    const fhMinus3 = props.fhMinus3;
    const fhAvg = props.fhAvg;
    const saldibalans = props.saldibalans;
    const calculateVoorschot = props.calculateVoorschot;
    const opgeteld = props.opgeteld;
    const betrokkene = props.betrokkene;

    return (
        <div>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                {/* <div style={{ padding: 2, textAlign: "center" }}> */}
                <IconButton>
                    <Button variant="outlined" endIcon={<CalculateIcon />} onClick={calculateVoorschot} disabled={fhMinus3.dataChanged || fhMinus2.dataChanged || fhMinus1.dataChanged || fhAvg.dataChanged || opgeteld.dataChanged || saldibalans.dataChanged || betrokkene.voorSchotCalculated}>Calculate VoorSchot</Button>
                </IconButton>
                <TableContainer component={Paper} style={{ maxHeight: 550 }}>
                    <Paper sx={{ padding: 2, textAlign: "center" }}>
                        <RekendeelTable
                            fhMinus1={fhMinus1}
                            fhMinus2={fhMinus2}
                            fhMinus3={fhMinus3}
                            fhAvg={fhAvg}
                            saldibalans={saldibalans}
                            opgeteld={opgeteld}
                            betrokkene={betrokkene}
                            printSet="all"
                        />
                    </Paper>
                </TableContainer>
                {/* </div> */}
            </Container>
        </div>
    )

}